var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbArrowMinimize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.293 1.293a1 1 0 011.414 0L6 4.586V3a1 1 0 012 0v4a1 1 0 01-1 1H3a1 1 0 010-2h1.586L1.293 2.707a1 1 0 010-1.414zm16 0a1 1 0 111.414 1.414L15.414 6H17a1 1 0 110 2h-4a1 1 0 01-1-1V3a1 1 0 112 0v1.586l3.293-3.293zM2 13a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 11-2 0v-1.586l-3.293 3.293a1 1 0 01-1.414-1.414L4.586 14H3a1 1 0 01-1-1zm10 0a1 1 0 011-1h4a1 1 0 110 2h-1.586l3.293 3.293a1 1 0 01-1.414 1.414L14 15.414V17a1 1 0 11-2 0v-4z",
    fill: "#111"
  })));
}

export default SvgIbArrowMinimize;